import http from '@/biz/http.mjs'

export default {
    readList: args => http.get(
        '/rulemRm/listRulemRmRule',
        {...args, ruleType: 'ROLE'}
    ),
}
